/* YUMAMI theme · minimal interactivity */
(function () {
  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('open');
    }
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = thumb.getAttribute('data-full');
    }
  });
})();
